const DEFAULT_PLANTILLA_GRUPO = '{resumen_grupo}';

/**
 * Aplica plantilla de envío por grupo con variables del API y datos del destinatario.
 */
export function aplicarPlantillaGrupo(plantilla, variables = {}, destinatario = {}) {
  const texto = plantilla || DEFAULT_PLANTILLA_GRUPO;
  const vars = variables || {};
  const dest = destinatario || {};

  return texto
    .replace(/{grupo_nombre}/g, vars.grupo_nombre ?? '')
    .replace(/{total_integrantes}/g, vars.total_integrantes ?? '')
    .replace(/{total_debitos}/g, vars.total_debitos ?? '')
    .replace(/{total_creditos}/g, vars.total_creditos ?? '')
    .replace(/{saldo_consolidado}/g, vars.saldo_consolidado ?? '')
    .replace(/{resumen_grupo}/g, vars.resumen_grupo ?? '')
    .replace(/{fecha}/g, vars.fecha ?? '')
    .replace(/{fecha_desde}/g, vars.fecha_desde ?? '')
    .replace(/{fecha_hasta}/g, vars.fecha_hasta ?? '')
    .replace(/{formato_resumen}/g, vars.formato_resumen ?? '')
    .replace(/{destinatario_razon_social}/g, dest.razon_social ?? '')
    .replace(/{destinatario_cuit}/g, dest.cuit ?? '')
    .replace(/{destinatario_telefono}/g, dest.telefono ?? dest.celular ?? '')
    .replace(/{destinatario_email}/g, dest.email ?? '');
}

export { DEFAULT_PLANTILLA_GRUPO };
